import '../../scss/components/agenciesSearchForm.scss'

const asForm = {
  $f: $('form[name="asForm"]'),

  locate (d, s) {
    const _this = this
    _this.$f.load()
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: location.origin + '/nos-agences/locate',
      data: { d: d, s: s },
      success: function (response) {
        document.location = location.origin + '/nos-agences/' + response.agency
      },
      error: function () {
        _this.$f.find('.alert').html('Aucune agence trouvée&nbsp;!').removeClass('d-none').addClass('text-danger')
        _this.$f.load(false)
      }
    })
  },

  init () {
    const _this = this
    _this.$f.on('submit', function (e) {
      // vérifie l'agence la plus proche de la ville saisie et redirige vers elle
      if ($(this).find('input[name="location"]').val() !== '' && $(this).find('input[name="department"]').val() !== '') {
        e.preventDefault()
        _this.locate($(this).find('input[name="department"]').val(), $(this).find('input[name="slug"]').val())
      }
    })
  }

}

asForm.init()
